<template>
    <div class="m-fiscanStudyStats">
        <el-row :gutter="20" class="credit-wrap">
            <el-col :span="6" class="credit-left">
                <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
            </el-col>
            <el-col :span="18" class="credit-right">
                <ui-card :title="$t('c.learningStatistics')" icon="nucfont inuc-menu-assemble" class="ibox">
                    <a :href="href" ref="downLoad" id="export-l"></a>
                    <el-form class="rank-query" :model="formSearch" :inline="true" size="mini">
                        <el-form-item :label="$t('c.userInfo')">
                            <el-input v-model="formSearch.search" :placeholder="$t('tip.userSearch')"
                                      @keyup.enter.native="clickSearch" clearable></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('c.date')">
                            <el-date-picker
                                v-model="formSearch.afterDate"
                                type="date"
                                :placeholder="$t('tip.startTime')"
                                :picker-options="pickerOptions1"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <span>{{$t('c.to')}}</span>
                            <el-date-picker
                                v-model="formSearch.beforeDate"
                                type="date"
                                :placeholder="$t('tip.endTime')"
                                :picker-options="pickerOptions2"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="clickSearch" round>{{$t('c.query')}}</el-button>
                        </el-form-item>
                    </el-form>
                    <el-tooltip class="item" effect="dark" :content="$t('c.exportLearnStats')" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" class="export-excel" @click="exportLearning">
                            <i class="nucfont inuc-daochu"></i>
                        </el-button>
                    </el-tooltip>
                    <div class="fiscan-table">
                        <data-tables ref="examTable"
                                     :data="tableData"
                                     :table-props="tableProps"
                                     :current-page.sync="currentPage"
                                     :page-size="20"
                                     :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                     header-align="center"
                        >
                            <el-table-column type="index" width="40" align="center">
                            </el-table-column>
                            <!-- column title -->
                            <el-table-column :label="$t('c.username')" align="center" property="userName" sortable
                                             show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{scope.row.userName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('c.account')" align="center" property="account" sortable
                                             show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column :label="$t('c.belong')" align="center" property="orgName" sortable
                                             show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column :label="$t('c.imageLearn')" align="center" property="number" sortable
                                             show-overflow-tooltip>

                            </el-table-column>
                            <el-table-column :label="$t('c.studyTime')" align="center" property="duration" sortable
                                             show-overflow-tooltip>
                            </el-table-column>

                            <!-- column buttons -->
                            <el-table-column :label="$t('c.operation')" align="center" width="90">
                                <div class="btn-cell" slot-scope="scope">
                                    <i class="nucfont inuc-preview"
                                       :title="$t('c.view')"
                                       @click="viewCreditDetail(scope.row)"></i>
                                </div>
                            </el-table-column>
                        </data-tables>
                    </div>
                </ui-card>
            </el-col>
        </el-row>
<!--        <transition enter-active-class="animated zoomInRight"-->
<!--                    leave-active-class="animated zoomOutUp">-->
<!--            <router-view></router-view>-->
<!--        </transition>-->
    </div>
</template>
<script>
    import api from '@/api';
    import { Ticket, Debounce } from '@/utils';
    import StatisticsMultiOrgs from '@components/Statistics/StatisticsMultiOrgs';
    import uiCard from '@components/Statistics/StatisticUICard';
    import qs from 'qs'

    export default {
        data() {
            return {
                searchData: {
                    orgIDs: [],
                    type: undefined,
                },
                sourceType: this.$t('c.all'),
                pictureRate: '0%',
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                tableData: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: document.documentElement.clientHeight-430
                    // height: "auto"
                },
                currentPage: 1,
                formSearch: {
                    search: '',
                    afterDate: '',
                    beforeDate: '',
                    limit: -1
                },
                href: ''
            };
        },
        created() {
        },
        mounted() {

        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.beforeDate) return false;
                        return time.getTime() > new Date(that.formSearch.beforeDate).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.afterDate) return false;
                        let dateTime = new Date(that.formSearch.afterDate);
                        dateTime = dateTime.setDate(dateTime.getDate()-1);
                        return time.getTime() < new Date(dateTime).getTime()
                    },
                }
            },
        },
        methods: {
            orgDataLoaded() {
                $('.el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
            },
            orgsChange: Debounce(function (data) {
                this.sourceType = this.$t('c.all');
                this.searchData.orgIDs = data;

                let searchData = {
                    orgIDs: this.searchData.orgIDs,
                    ...this.formSearch
                };

                this.currentPage = 1;
                this.query(searchData)

            }, 600),
            clickSearch() {
                let searchData = {
                    orgIDs: this.searchData.orgIDs,
                    ...this.formSearch
                };
                this.currentPage = 1;
                this.query(searchData)
            },
            query(data) {
                api.getFiscanImageStatistic(data).then((res) => {
                    if (res.package) {
                        res.package.forEach((v, index) => {
                            v.duration = this.getHMSTime(v.duration)
                        })
                        this.tableData = res.package;
                    }
                })
            },
            viewCreditDetail(data) {
                this.$router.push({
                    name: 'fiscanStudyDetail',
                    params: {
                        userID: data.userid,
                    },
                    query: {
                        afterDate: this.formSearch.afterDate,
                        beforeDate: this.formSearch.beforeDate,
                        userName: data.userName,
                    }
                })
            },

            getHMSTime (second_time) {
                var time = second_time + "秒";
                if( second_time > 60){
                    var second = parseInt(second_time) % 60;
                    var min = parseInt(second_time / 60);
                    time = min + "分钟" + second + "秒";
                    if( min > 60 ){
                        min = parseInt(second_time / 60) % 60;
                        var hour = parseInt( parseInt(second_time / 60) /60 );
                        time = hour + "小时" + min + "分钟" + second + "秒";
                        if( hour > 24 ){
                            hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                            var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                            time = day + "天" + hour + "小时" + min + "分钟" + second + "秒";
                        }
                    }
                }
                return time
            },
            exportLearning(formName) {

                const token = Ticket.get().access_token;
                const culture = this.$i18n.locale;

                let queryData = {
                    ...this.formSearch,
                    orgIds: this.searchData.orgIDs,
                    access_token: token
                };

                this.href = APIURI + 'api/Export/excel/fiscan-image-study/report?' + qs.stringify(queryData, {
                    indices: false
                });

                this.$nextTick(() => {
                    $('#export-l')[0].click();
                });
            },

        },
        watch: {},
        components: {
            StatisticsMultiOrgs,
            uiCard,
        }
    };
</script>
<style scoped lang="scss">
    @import '../../../style/const';

    $rankColor: #ffb822;
    .m-fiscanStudyStats {
        /deep/ .ui-card {
            margin-bottom: 0;
            box-shadow: none;
            border: 1px solid #dedede;

            .card-body {
                max-height: 670px;
            }
        }
    }

    .credit-wrap, .credit-right, .grid-content, .ibox {
        height: 100%;
    }

    .credit-wrap {
        display: flex;
    }

    .credit-left {
        & /deep/ .ibox {
            height: 100%;
            .el-tree {
                height: 100%;
            }
        }
    }

    .credit-right {
        .rank-query {
            padding: 20px 0 0 10px;
        }
    }

    .export-excel {
        margin: 0 0 10px 10px;
    }
</style>
